import { ref } from "vue";
import axios from "axios";

export default function useFolders() {
    const controller = new AbortController();
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    const folders = ref();
    const folderWithoutSync = ref();
    const foldersToPlanned = ref();
    const pendingFolders = ref();
    const folder = ref();
    const searchFolders = ref();

    const fetchFolders = async () => {
        let response = await axios.get("/api/folders");
        folders.value = response.data;
    };

    const fetchFolder = async (folder_id) => {
        let response = await axios.get(`/api/folders/${folder_id}`);
        folder.value = response.data;
    };

    const fetchFolderWithoutSync = async (folder_id) => {
        let response = await axios.get(
            `/api/folders/${folder_id}/without_sync`,
        );
        folderWithoutSync.value = response.data;
    };

    const fecthFoldersWithoutInterventions = async () => {
        let response = await axios.get("/api/folders_to_planned");
        foldersToPlanned.value = response.data;
    };

    const fecthPendingFolders = async () => {
        let response = await axios.get("/api/pending_folders");
        pendingFolders.value = response.data;
    };

    const updateFolder = async (info) => {
        await axios.patch(`/api/folders/${info.folder.id}`, info);
    };

    const destroyFolder = async (folder) => {
        await axios.delete(`/api/folders/${folder.id}`);
    };

    const updateStock = async (info) => {
        await axios.patch(
            `/api/update_stock_folder/${info.selected_folder.id}`,
            info,
        );
    };

    const searchFoldersByParam = async (param, canCancelToken = null) => {
        let response = await axios.post(`/api/search_folders_by_param`, param, {
            cancelToken: canCancelToken?.token,
        });
        searchFolders.value = response.data;
    };

    const updateHasInterventions = async (folder) => {
        await axios.get(`/api/update_has_interventions/${folder.id}`);
    };

    const getFoldersWithStartFab = async () => {
        const response = await axios.get(
            "/api/get_folder_with_start_fab_and_no_billing",
        );
        return response;
    };

    const updateIsKitchenInstalled = async (folderId) => {
        const response = await axios.get(
            `/api/set_is_kitchen_installed/${folderId}`,
        );
        return response;
    };

    const updateIsControlled = async (folderId) => {
        const response = await axios.get(`/api/set_is_controlled/${folderId}`);
        return response;
    };

    const getStatsBe = async (start, end) => {
        const response = await axios.get(`/api/get_stats_be/${start}/${end}`);
        return response;
    };

    const fetchSilceDetails = async (id) => {
        const response = await axios.get(`/api/details/folders/${id}`);
        return response.data;
    };

    const forceUpdate = async (id) => {
        await axios.get(`/api/force_update_folder/${id}`);
    };

    const restore = async (id) => {
        await axios.get(`/api/restore_folder/${id}`);
    };

    source.cancel("Operation canceled by the user.");

    return {
        folders,
        foldersToPlanned,
        pendingFolders,
        folder,
        searchFolders,
        fetchFolder,
        fetchFolderWithoutSync,
        fetchFolders,
        fecthFoldersWithoutInterventions,
        fecthPendingFolders,
        updateFolder,
        destroyFolder,
        updateStock,
        searchFoldersByParam,
        updateHasInterventions,
        getFoldersWithStartFab,
        updateIsKitchenInstalled,
        updateIsControlled,
        getStatsBe,
        fetchSilceDetails,
        forceUpdate,
        restore,
    };
}
